<div class="p-card" style="max-width: 800px" [formGroup]="form">
    <div class="p-card-title p-mb-2 p-mt-4" style="font-weight: bold">
        🎉 {{ 'home.onboardingProfile.almostDone' | translate }}
    </div>
    <div class="p-card-subtitle p-mb-3">
        {{ 'home.onboardingProfile.informationAboutOnboarding' | translate }}
    </div>

    <div class="p-card-subtitle">
        <div>{{ 'home.onboardingProfile.presentYourself' | translate }}</div>
        <div>{{ 'home.onboardingProfile.descriptionIsShownOnProfile' | translate }}</div>
    </div>

    <textarea
        class="form-control"
        rows="3"
        id="user_description"
        aria-describedby="userDescription"
        formControlName="description"
    ></textarea>
    <div class="text-right mt-1">
        <small class="text-muted"> {{ form.get('description').value?.length || 0 }} / 2600 </small>
    </div>

    <div class="p-d-flex p-ai-center p-mt-3">
        <div class="avatar-container">
            <div class="p-d-flex p-ai-center">
                <div class="p-relative">
                    <p-avatar
                        *ngIf="hasProfilePicture"
                        [image]="this.accountsService.currentUser.profilePicture"
                        styleClass="p-mr-2"
                        size="xlarge"
                        shape="circle"
                        (click)="imageCropModal.showModal()"
                    ></p-avatar>
                    <p-badge
                        *ngIf="hasProfilePicture"
                        value="x"
                        severity="danger"
                        [style]="{
                            cursor: 'pointer',
                            position: 'absolute',
                            bottom: '0',
                            right: '0',
                            fontSize: '0.8rem',
                            width: '1.2rem',
                            height: '1.2rem',
                            minWidth: 'unset',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }"
                        pTooltip="Supprimer la photo ajoutée"
                        tooltipPosition="top"
                        (click)="removePicture()"
                    ></p-badge>
                </div>
            </div>
            <p-avatar
                *ngIf="!hasProfilePicture"
                icon="pi pi-user"
                styleClass="p-mr-2"
                size="xlarge"
                shape="circle"
                (click)="imageCropModal.showModal()"
            ></p-avatar>
        </div>

        <image-crop-modal
            [cropperParams]="cropperParams"
            [imageService]="imageService"
            (eventSavePicture)="savePicture()"
        ></image-crop-modal>

        <div class="p-ml-2">
            <div>{{ 'home.onboardingProfile.addPicture' | translate }}</div>
            <div>{{ 'home.onboardingProfile.pictureMaxSize' | translate }}</div>
        </div>
    </div>
</div>
